export const HEADER_HEIGHT = 140;
export const MOBILE_SCREEN_WIDTH = 768;
export const LARGE_PLUS_SCREEN_WIDTH = 1300;
export const OVERLAY_ACTIVE_CLASS = 'Overlay--active';
